import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "container footer" }
const _hoisted_2 = { class: "text-muted credit" }

import { computed } from "vue";


export default /*@__PURE__*/_defineComponent({
  __name: 'Footer',
  setup(__props) {

const currentYear = computed(() => new Date().getFullYear());

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("p", _hoisted_2, "© " + _toDisplayString(currentYear.value) + " | Aligera", 1)
  ]))
}
}

})